module.exports = {"370685001":"罗峰街道","370685002":"泉山街道","370685003":"梦芝街道","370685004":"温泉街道","370685005":"大秦家街道","370685101":"辛庄镇","370685102":"蚕庄镇","370685103":"金岭镇","370685104":"毕郭镇","370685105":"玲珑镇","370685106":"张星镇","370685108":"夏甸镇","370685109":"阜山镇","370685110":"齐山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370685.json
// module id = 1409
// module chunks = 0